import { calculateRiderPremiumForVaryingSumAssured as calculateRiderPremium } from 'core/service/rider/premium-calculation'
import { queryPremiumRateForCPR as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { queryTaxRateForCPR as queryTaxRate } from 'core/service/rider/query-tax-rate'

export default {
  calculateRiderPremium,
  queryPremiumRate,
  queryTaxRate,
}
